class Dropdown {
	constructor(el) {
		this.el = el;
		this.isOpen = false;

		this.bindUI();
		this.init();
		this.bindEvents();
	}

	bindUI() {
		this.toggleBtn = this.el.querySelector('.js-dropdown-toggle');
		this.content = this.el.querySelector('.js-dropdown-content');
		this.contentInner = this.el.querySelector('.js-dropdown-content-inner');
		this.iconPlus = this.el.querySelector('.js-dropdown-toggle-icon-plus');
		this.iconMinus = this.el.querySelector('.js-dropdown-toggle-icon-minus');
	}

	bindEvents() {
		this.toggleBtn.addEventListener('click', () => this.toggle());
	}

	init() {
		this.timeline = gsap.timeline({
			paused: true,
		});

		this.timeline.to(this.content, {
			height: 'auto',
			duration: 0.5,
			ease: 'power2.inOut',
		}, "start");

		this.timeline.from(this.contentInner, {
			y: 15,
			duration: 0.5,
			ease: 'power2.inOut',
		}, "start");

		// Open by default
		if (this.el.classList.contains('open')) {
			this.timeline.progress(1);
			this.isOpen = true;
		}
		
		this.updateIcons();
	}

	updateIcons() {
		if (this.iconPlus) this.iconPlus.style.display = this.isOpen ? 'none' : '';
		if (this.iconMinus) this.iconMinus.style.display = this.isOpen ? '' : 'none';
	}

	toggle() {
		!this.isOpen ? this.timeline.play() : this.timeline.reverse();
		this.isOpen = !this.isOpen;
		this.el.classList.toggle('open', this.isOpen);
		this.updateIcons();
	}
}

function initDropdowns() {
	document.querySelectorAll('.js-dropdown').forEach(function(el) {
		new Dropdown(el);
	});
}

// Initialisation après le chargement de la page
window.addEventListener('font-size-updated', initDropdowns);
